//data-src.js
import {onLoad} from "../base/onLoad";

onLoad(() => {
    const elements = document.querySelectorAll('[data-src]');
    window.addEventListener('scroll', function handler(e) {
        window.removeEventListener('scroll', handler);
        elements.forEach(i => new DataSrc(i as HTMLElement));
    });
});

class DataSrc {
    private element: HTMLElement;
    private readonly src: string|null;

    private readonly dataSrcAttribute = 'data-src';
    private readonly srcAttribute = 'src';

    constructor(element: HTMLElement) {
        this.element = element;

        this.src = this.fetchDataSrc();

        if(this.src) {
            this.setDataSrc();
        }

        this.cleanup();
    }

    private setDataSrc() {
        this.element.setAttribute(this.srcAttribute, this.src as string);
    }

    private fetchDataSrc(): string|null {
        return this.element.getAttribute(this.dataSrcAttribute);
    }

    private cleanup() {
        this.element.removeAttribute(this.dataSrcAttribute);
    }
}